<script>

import { Overlay } from '../../'

export default {
    name: 'FisherTransform',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Fisher Transform - Converts price to Gaussian normal distribution',
                preset: {
                    name: 'Fisher Transform $length',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#00bcd4'
                    }
                }
            }
        },
        use_for() { return ['FisherTransform'] },
        calc() {
            return {
                props: {
                    length: { def: 14, text: 'Length' }
                },
                conf: { renderer: 'Splines' },
                update: `
                    // Fisher Transform calculation
                    let max_h = highest(high, length)[0]
                    let min_l = lowest(low, length)[0]
                    
                    if (max_h === min_l) return 0
                    
                    let value = (close[0] - min_l) / (max_h - min_l)
                    value = 2 * value - 1
                    
                    // Clamp value to avoid log errors
                    value = Math.max(-0.999, Math.min(0.999, value))
                    
                    let fisher = 0.5 * Math.log((1 + value) / (1 - value))
                    
                    return fisher
                `
            }
        }
    }
}
</script>
